module.exports = __webpack_public_path__ + "icon-alertminer-warranty.320c61d950849d1a2cc7.png";